"use client";

import { useState } from "react";
import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";

export default function BundleBanner() {
  const [added, setAdded] = useState(false);

  const handleAdd = () => {
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <section
      className="my-12 rounded-4xl overflow-hidden shadow-dreamy-xl relative"
      style={{
        background: "linear-gradient(135deg, #4A2C6E 0%, #7B4FA6 50%, #C8B6E2 100%)"
      }}
      aria-label="Featured bundle offer">
      
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full blur-3xl opacity-20" style={{ background: "var(--peach)" }} />
      <div className="absolute bottom-0 left-1/4 w-48 h-48 rounded-full blur-2xl opacity-15" style={{ background: "var(--gold)" }} />
      <div className="relative z-10 p-8 md:p-12 grid md:grid-cols-2 gap-8 items-center">
        {/* Left */}
        <div>
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur rounded-full px-4 py-2 text-xs font-black text-white mb-5">
            <Icon name="SparklesIcon" size={14} variant="solid" className="text-gold" />
            LIMITED TIME BUNDLE OFFER
          </div>
          <h2 className="font-fraunces text-3xl md:text-4xl font-black text-white leading-tight mb-4">
            The Ultimate
            <span className="italic text-lavender block">Starter Bundle</span>
          </h2>
          <p className="text-white/70 text-sm leading-relaxed mb-6">
            Get the ABC Wonderland + 123 Rainbow Numbers + Tracing & Writing Starter + a 24-piece colored pencil set — everything your child needs to begin their creative journey.
          </p>

          {/* Value breakdown */}
          <div className="flex flex-wrap gap-3 mb-6">
            {["ABC Book", "123 Book", "Tracing Book", "Color Pencils"]?.map((item) =>
            <span key={item} className="flex items-center gap-1.5 bg-white/15 backdrop-blur rounded-full px-3 py-1.5 text-xs font-bold text-white">
                <Icon name="CheckCircleIcon" size={14} variant="solid" className="text-green-400" />
                {item}
              </span>
            )}
          </div>

          <div className="flex items-center gap-4 mb-6">
            <div>
              <span className="font-fraunces text-4xl font-black text-white">$34.99</span>
              <span className="text-white/50 line-through text-lg ml-2">$57.96</span>
            </div>
            <div className="bg-gold text-plum text-xs font-black px-3 py-1.5 rounded-full">
              SAVE 40%
            </div>
          </div>

          <button
            onClick={handleAdd}
            className={`flex items-center gap-2 text-sm font-bold px-8 py-4 rounded-full transition-all duration-300 ${
            added ?
            "bg-green-400 text-white scale-95" : "bg-white text-plum hover:bg-white/90 shadow-dreamy"}`
            }
            aria-label="Add starter bundle to cart">
            
            {added ?
            <>
                <Icon name="CheckIcon" size={18} variant="solid" />
                Added to Cart!
              </> :

            <>
                <Icon name="ShoppingBagIcon" size={18} variant="solid" />
                Add Bundle to Cart
              </>
            }
          </button>
        </div>

        {/* Right — stacked images */}
        <div className="relative h-56 md:h-72 hidden md:block">
          <div className="absolute top-0 left-8 w-32 h-40 rounded-2xl overflow-hidden border-4 border-white/30 shadow-dreamy-xl rotate-[-8deg] float-a">
            <AppImage
              src="https://img.rocket.new/generatedImages/rocket_gen_img_12a0514d5-1770228302402.png"
              alt="ABC Wonderland coloring book included in starter bundle"
              fill
              className="object-cover" />
            
          </div>
          <div className="absolute top-4 left-1/3 w-32 h-40 rounded-2xl overflow-hidden border-4 border-white/30 shadow-dreamy-xl rotate-[3deg] float-b">
            <AppImage
              src="https://img.rocket.new/generatedImages/rocket_gen_img_12a0514d5-1770228302402.png"
              alt="123 Rainbow Numbers coloring book included in starter bundle"
              fill
              className="object-cover" />
            
          </div>
          <div className="absolute top-10 right-8 w-32 h-40 rounded-2xl overflow-hidden border-4 border-white/30 shadow-dreamy-xl rotate-[7deg] float-c">
            <AppImage
              src="https://images.unsplash.com/photo-1646228803325-6118e7e0f107"
              alt="Art accessories and colored pencils included in starter bundle"
              fill
              className="object-cover" />
            
          </div>
        </div>
      </div>
    </section>);

}